// extracted by mini-css-extract-plugin
export default {"wrapper":"h2-z","play":"i2-z"};